import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Accounts = ({ fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.tab.default;

  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.375 16.5V5.5H3.875V16.5H0.375ZM6.625 16.5V0.5H10.125V16.5H6.625ZM12.875 16.5V9.5H16.375V16.5H12.875Z"
        fill={fill}
      />
    </svg>
  );
};
